module.exports = __webpack_public_path__ + "img/whathot_big02_words.dbb1a917.jpg";